function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Component, createRef } from 'react';
import { renderErrors } from "../../utils";
import { hasError } from "../../utils/hasError/hasError";
import { CheckboxContainer, CheckboxInput, CheckboxLabel, Checkmark, ErrorMessage } from "./Checkbox.styles";
import { CheckboxContext } from "./checkboxContext/CheckboxContext";
import { CheckboxGroup } from "./checkboxGroup/CheckboxGroup";
export var Checkbox =
/*#__PURE__*/
function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox(props) {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Checkbox).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "ref", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isError", function () {
      return _this.props.meta && hasError(_this.props.meta, false);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClick", function () {
      if (_this.ref.current) {
        _this.ref.current.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isChecked", function (value, name) {
      return value.indexOf(name) > -1;
    });

    _this.ref = createRef();
    return _this;
  }

  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          input = _this$props.input,
          label = _this$props.label,
          name = _this$props.name,
          className = _this$props.className,
          style = _this$props.style,
          meta = _this$props.meta;

      if (input) {
        return React.createElement(CheckboxContainer, {
          style: style,
          className: className
        }, React.createElement(CheckboxLabel, {
          className: "checkbox__label ".concat(input.name ? "checkbox__label--".concat(input.name.replace('|', '-')) : ''),
          onClick: this.onClick,
          ref: this.ref
        }, label, React.createElement(CheckboxInput, _extends({}, input, {
          type: "checkbox"
        })), React.createElement(Checkmark, null)), meta && this.isError() && React.createElement(ErrorMessage, {
          className: "input-error"
        }, renderErrors(meta.error, meta.submitError)));
      }

      if (this.context.checkboxGroup && name) {
        var _this$context$checkbo = this.context.checkboxGroup,
            value = _this$context$checkbo.value,
            onChange = _this$context$checkbo.onChange;
        var isChecked = this.isChecked(value, name);
        return React.createElement(CheckboxContainer, {
          style: style,
          className: className
        }, React.createElement(CheckboxLabel, {
          onClick: this.onClick,
          ref: this.ref,
          className: "checkbox__label ".concat(name ? "checkbox__label--".concat(name.replace('|', '-')) : '')
        }, label, React.createElement(CheckboxInput, {
          onChange: onChange,
          name: name,
          checked: isChecked,
          type: "checkbox"
        }), React.createElement(Checkmark, null)));
      }

      console.error('Checkbox requires to be passed FinalForm complient input or placed in CheckboxGroup Context and passed name');
      return null;
    }
  }]);

  return Checkbox;
}(Component);

_defineProperty(Checkbox, "Group", CheckboxGroup);

_defineProperty(Checkbox, "contextType", CheckboxContext);